/** PVM AG / GPS factsheet header assets and contact block. */

export const PVM_GPS_LEFT_LOGO = '/images/gps-logo.png';
export const PVM_GPS_RIGHT_LOGO = '/images/pvm-partners-logo.png';

export type PvmContactLine = { text: string; bold?: boolean };

export const PVM_GPS_CONTACT_LINES: PvmContactLine[] = [
  { text: 'PARTNERS VermögensManagement AG', bold: true },
  { text: 'Südliche Auffahrtsallee 37' },
  { text: '80639 München' },
  { text: 'Tel.: + 49 89 24 21 39 0' },
  { text: 'Fax: + 49 89 24 21 39 19' },
  { text: 'www.pvm-ag.de', bold: true },
  { text: 'www.linkedin.com/company/pvm-ag.de' },
];

/** Left logo: bundled GPS asset; honour template only when explicitly set to gps-logo path. */
export function resolvePvmGpsLeftLogoUrl(templateIconUrl?: string | null): string {
  const url = templateIconUrl?.trim();
  if (url && (url === PVM_GPS_LEFT_LOGO || url.includes('gps-logo') || url.includes('gps_logo'))) {
    return url;
  }
  return PVM_GPS_LEFT_LOGO;
}

/** PVM header layout sizes. */
export const PVM_HEADER_LEFT_LOGO_WIDTH_WEB = 130;
export const PVM_HEADER_RIGHT_LOGO_WIDTH_WEB = 140;
export const PVM_HEADER_RIGHT_LOGO_HEIGHT_WEB = 26;
/** Compact PARTNERS logo on the disclaimer row (right), above the top header border. */
export const PVM_HEADER_TOP_LOGO_WIDTH_WEB = 70;
export const PVM_HEADER_TOP_LOGO_HEIGHT_WEB = 8;
export const PVM_HEADER_LEFT_LOGO_WIDTH_PDF = 95;
export const PVM_HEADER_LEFT_LOGO_HEIGHT_PDF = 42;
export const PVM_HEADER_RIGHT_LOGO_WIDTH_PDF = 110;
export const PVM_HEADER_RIGHT_LOGO_HEIGHT_PDF = 20;
export const PVM_HEADER_TOP_LOGO_WIDTH_PDF = 52;
export const PVM_HEADER_TOP_LOGO_HEIGHT_PDF = 6;
/** Space between top border line and main header row. */
export const PVM_HEADER_PADDING_BELOW_TOP_BORDER_WEB = 8;
export const PVM_HEADER_PADDING_BELOW_TOP_BORDER_PDF = 5;
export const PVM_HEADER_RIGHT_COLUMN_WIDTH_WEB = 200;
export const PVM_HEADER_RIGHT_COLUMN_WIDTH_PDF = 180;
/** Equal side columns so "Global Premium Select | P" sits visually centered. */
export const PVM_HEADER_SIDE_COLUMN_WIDTH_WEB = 200;
export const PVM_HEADER_SIDE_COLUMN_WIDTH_PDF = 180;
